import { Component, OnDestroy, OnInit } from '@angular/core';
import { OrderStateService } from '../../../order/services/order-state.service';
import { OrderInfo } from '../../../order/models/order-info';
import { Router } from '@angular/router';
import { PartnerStateService } from '../../services/partner-state.service';
import { PartnerStateEnum } from '../../services/partner-state.enum';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { LoggerService } from '../../../../services/logger/logger.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit, OnDestroy {

  private _orders: OrderInfo[];
  private allOrdersSubscribe: Subscription;

  constructor(
    private orderStateService: OrderStateService,
    private partnerStateService: PartnerStateService,
    private router: Router,
    private loadingSpinnerService: LoadingSpinnerService,
    private logger: LoggerService,
  ) {
  }

  ngOnInit() {
    this.loadAllOrders();
  }

  loadAllOrders() {
    this.allOrdersUnsubscribe();
    this.allOrdersSubscribe = this.orderStateService.allOrders.subscribe(
      (orders: OrderInfo[]) => {
        this._orders = orders;
      }
    );
  }

  ngOnDestroy() {
    this.allOrdersUnsubscribe();
  }

  allOrdersUnsubscribe() {
    if (this.allOrdersSubscribe) {
      this.allOrdersSubscribe.unsubscribe();
      this.allOrdersSubscribe = null;
    }
  }

  resetAllOrders() {
    this.loadAllOrders();
  }

  get orders(): OrderInfo[] {
    return this._orders;
  }

  orderClick(orderId: number) {
    this.partnerStateService.update(PartnerStateEnum.ShowOrder, null, orderId);
  }

  paymentClick(orderId: number) {
    this.orderStateService.reset();
    this.orderStateService.sessionOrderId = orderId;
    this.router.navigateByUrl('payment/start');
  }

  cancelClick(orderId: number) {
    if (!orderId) {
      return;
    }
    this.loadingSpinnerService.show();
    this.orderStateService.cancelOrder(orderId).subscribe(
      result => {
        this.resetAllOrders();
        this.loadingSpinnerService.hide();
      },
      error => {
        this.logger.error(error);
        this.resetAllOrders();
        this.loadingSpinnerService.hide();
      }
    );
  }
}
